<ng-container *ngIf="!!page">
    <tt-card>
        <tt-input ttLabel="stockplace_name" [(ttModel)]="page.stockplace_name" ttReadonly></tt-input>
        <tt-input ttLabel="transportarea_name" [(ttModel)]="page.transportarea_name"></tt-input>
        <tt-button-save ttText="transportarea_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</ng-container>
